import * as UUID from 'uuid'
import useSubmitDocumentGeneration from '../../document/useSubmitDocumentGeneration'
import { QueueCallbacks } from '../../queue/queueTypes'
import { DocumentGenerationContextData, DocumentGenerationStatusData, DocumentGenerationType } from '../../document/documentGenerationTypes'
import { PersistInvoiceDto } from './usePersistInvoice'

export type InvoiceParams = {
    invoiceId: string
}

export type SubmitInvoiceDocumentGeneration = (
    data: PersistInvoiceDto,
    callbacks?: QueueCallbacks<InvoiceParams, DocumentGenerationStatusData, DocumentGenerationContextData>,
) => void

export default function useSubmitInvoiceDocumentGeneration(
    generationType: DocumentGenerationType,
    hookCallbacks?: QueueCallbacks<InvoiceParams, DocumentGenerationStatusData, DocumentGenerationContextData>,
): SubmitInvoiceDocumentGeneration {
    const submit = useSubmitDocumentGeneration<InvoiceParams, DocumentGenerationStatusData>(generationType)

    return (data, dispatchCallbacks) => {
        // Dispatching is fire-and-forget: the generation is reported back over the websocket and surfaced
        // through the callbacks below, so there is nothing here to await. This used to be wrapped in a
        // Promise.all that resolved immediately, which made every caller think it could wait for the documents.
        ;(data.children || [{ ...data }]).forEach(invoice => {
            submit({
                requestId: UUID.v4(),
                data: { invoiceId: invoice.invoiceId, generationType } as InvoiceParams,
                title: invoice.invoiceNumber,
                callbacks: {
                    ...(hookCallbacks || {}),
                    ...(dispatchCallbacks || {}),
                },
            })
        })
    }
}
